/* eslint-disable react/prefer-es6-class, react/prop-types, react/sort-comp, react/jsx-no-bind */
import React from 'react';
import * as Paths from 'es6/core/paths';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/home/panel-mixin';
import ProgressBar from 'es6/components/common/progress-bar';
import { ContentFigureSizes, ContentFigure } from 'es6/components/common/content-figure';

const SavedPanel = React.createClass({
  displayName: 'SavedPanel',

  mixins: [PanelMixin],

  getInitialState() {
    return {
      sortBy: 'study-progress',
      searchBy: '',
    };
  },

  getFilteredGoals() {
    return this.props.goals.filter((goal) => {
      const aggregate = this.props.aggregateMemories[goal.id];
      return aggregate.enrolled && !aggregate.focused;
    })
      .filter(this.filterBy)
      .sort(this.sortBy);
  },

  getNoCoursesMessage() {
    return t('course-tabs.saved-courses-no-courses');
  },

  render() {
    return (
      <div className="saved-courses" style={this.getPanelStyle()}>
        <header className="content-details course-filters">
          <div className="details-primary" />
          {this.renderSearchBox()}
        </header>

        <section className="courses">
          {this.renderGoals()}
        </section>

        {this.renderPagination()}
      </div>
    );
  },

  renderGoal(goal) {
    const aggregate = this.props.aggregateMemories[goal.id];
    let progress = aggregate.items.progress;

    return (
      <article key={goal.id} className="content-course">
        <div className="content-columns">
          <ContentFigure size={ContentFigureSizes.SMALL} imgSrc={goal.icon} />

          <section className="content-column course-details">
            <h2 className="course-title ellipsis">
              <a href={Paths.course(goal.id)} title={goal.title}>{goal.title}</a>
            </h2>

            <ProgressBar progress={progress} showProgressTag />

            <div className="study-stats">
              <ul className="content-columns content-stats">
                {this.renderStats(goal, aggregate)}
              </ul>
            </div>
          </section>

          {this.renderLauncher(goal)}

          <aside className="content-column course-actions">
            <a className="course-action" onClick={this.props.onFocus.bind(this, goal)}>{t('move-to-now-studying')}</a>
            <a className="course-action danger" onClick={this.props.onUnenroll.bind(this, goal)}>{t('remove-from-saved')}</a>
          </aside>
        </div>
      </article>
    );
  },
});

export default SavedPanel;
